"use strict";

// Load styles, for Webpack CSS Tree Shaking.
import "./style.scss";

import MmenuLight from "mmenu-light";

document.addEventListener('DOMContentLoaded', () => {
    const headerWrapper = document.querySelector('.header__wrapper');
    const nav = document.querySelector('.wp-block-navigation');
    const navWrapper = document.querySelector('.wp-block-nav__wrapper');
    
    /**
     * Create mobile nav icons
     */
    const siteBlocks = document.querySelector('.wp-site-blocks');
    const mobileMenu = document.createElement('div');
    mobileMenu.classList.add('mobile-menu');

    // Create left and right bar of mobile navigation
    const barSvgString = `
    <svg xmlns="http://www.w3.org/2000/svg" id="Group_3136" data-name="Group 3136" width="205.656" height="42.5" viewBox="0 0 205.656 42.5">
        <path id="Path_129" data-name="Path 129" d="M158.512,997.409c15.339-19.945,27.349-21.871,43.176-21.871H334.17v42.5H128.514C142.979,1014.88,150.226,1006.965,158.512,997.409Z" transform="translate(-128.514 -975.538)" fill="#fc4d3d"/>
    </svg>
    `;
    const emailIconSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="Group_3142" data-name="Group 3142" width="21.348" height="16.018" viewBox="0 0 21.348 16.018">
            <defs>
                <clipPath id="clip-path">
                <rect id="Rectangle_1814" data-name="Rectangle 1814" width="21.348" height="16.018" fill="none"/>
                </clipPath>
            </defs>
            <g id="Group_3141" data-name="Group 3141" clip-path="url(#clip-path)">
                <path id="Path_1258" data-name="Path 1258" d="M21.372,54.006v9.88a2.113,2.113,0,0,1-1.956,1.629l-17.6,0A2.141,2.141,0,0,1,.028,63.886v-9.88l9.144,6.072a3.365,3.365,0,0,0,3.056,0Z" transform="translate(-0.026 -49.503)" fill="#fff"/>
                <path id="Path_1259" data-name="Path 1259" d="M20.815,3.3,11.7,9.4a1.993,1.993,0,0,1-2.1-.033C6.558,7.721,3.592,5.1.567,3.335A1.968,1.968,0,0,1,1.794,0h17.76A1.972,1.972,0,0,1,20.815,3.3" transform="translate(0.001 0.001)" fill="#fff"/>
            </g>
        </svg>
    `;
    const homeIconSvg = `
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="20" viewBox="0 0 22 20">
        <g id="Group_3183" data-name="Group 3183" transform="translate(17361 19668)">
            <path id="Polygon_1" data-name="Polygon 1" d="M11,0,22,10H0Z" transform="translate(-17361 -19668)" fill="#fff"/>
            <rect id="Rectangle_1840" data-name="Rectangle 1840" width="6" height="11" transform="translate(-17359 -19659)" fill="#fff"/>
            <rect id="Rectangle_1841" data-name="Rectangle 1841" width="6" height="11" transform="translate(-17347 -19659)" fill="#fff"/>
            <rect id="Rectangle_1842" data-name="Rectangle 1842" width="18" height="3" transform="translate(-17359 -19659)" fill="#fff"/>
        </g>
        </svg>
    `;
    const leftBar = document.createElement('a');
    leftBar.classList.add('mobile-menu__bar', 'mobile-menu__bar--left');
    leftBar.href = '/';
    leftBar.innerHTML = barSvgString;
    leftBar.insertAdjacentHTML('beforeend', homeIconSvg);
    const rightBar = document.createElement('a');
    rightBar.classList.add('mobile-menu__bar', 'mobile-menu__bar--right');
    rightBar.href = '/contact';
    rightBar.innerHTML = barSvgString;
    rightBar.insertAdjacentHTML('beforeend', emailIconSvg);

    // Create mobile toggle
    const mobileToggle = document.createElement('div');
    mobileToggle.classList.add('mobile-toggle');
    const mobileToggleBars = document.createElement('div');
    mobileToggleBars.classList.add('mobile-toggle__bars');

    // Append mobile toggle to DOM
    mobileToggle.append(mobileToggleBars);
    mobileMenu.append(leftBar);
    mobileMenu.append(mobileToggle);
    mobileMenu.append(rightBar);
    siteBlocks.prepend(mobileMenu);

    // Check if user has scrolled and resize header accordingly
    function resizeNavItems() {
        const navLogo = document.querySelector('.header__logo a');
        const navLinks = nav.querySelectorAll('.wp-block-navigation-item__content');
        if (window.innerWidth <= 991) {
            navLogo.style.width = '';
            navLinks.forEach(navLink => {
                navLink.style.fontSize = `24px`;
            })

            const mobileNavButton = document.querySelector('.mm-ocd__content .wp-block-button__link');
            if (mobileNavButton) {
                mobileNavButton.style.fontSize = `20px`;
                mobileNavButton.style.padding = `10px`;
            }
            return;
        }

        const scrollTop = window.scrollY;
        if (scrollTop >= 500) {
            return;
        }
        const logoWidth = Math.round(((scrollTop >= 200 ? 200 : scrollTop) / 3));
        const navLinksFontSize = Math.round(((scrollTop >= 200 ? 200 : scrollTop) / 50));
        const buttonPaddingSize = Math.round(((scrollTop >= 200 ? 200 : scrollTop) / 20));

        navLogo.style.width = `${180 - logoWidth}px`;
        navLinks.forEach(navLink => {
            navLink.style.fontSize = `${20 - navLinksFontSize}px`;
        })

        const navButton = headerWrapper.querySelector('.wp-block-button__link');
        if (navButton) {
            navButton.style.fontSize = `${20 - navLinksFontSize}px`;
            navButton.style.padding = `${14 - buttonPaddingSize}px`;
        }
    }
    
    window.addEventListener('load', () => {
        resizeNavItems();
    });
    window.addEventListener('resize', () => {
        resizeNavItems();
    });
    window.addEventListener('scroll', () => {
        const header = document.querySelector('header.wp-block-template-part');
        const scrollY = window.scrollY;
        if (scrollY >= 200) {
            header.classList.add('has-scrolled');
        } else {
            header.classList.remove('has-scrolled');
        }

        resizeNavItems();
    });

    /**
     * Set up mobile nav
     */
    let myMenu = document.querySelector('.wp-block-nav__wrapper');
    const menu = new MmenuLight( myMenu, "(max-width: 992px)");
    const navigator = menu.navigation({
        title: '',
    });
    const drawer = menu.offcanvas();
    drawer.wrapper.classList.remove('mm-ocd--left');

    /**
     * Mobile Menu Toggle
     */
    if (mobileToggle) {
        mobileToggle.addEventListener('click', (event) => {
            event.preventDefault();

            mobileToggleBars.classList.toggle('show-mobile-menu');
            if (mobileToggleBars.classList.contains('show-mobile-menu')) {
                drawer.open();
            } else {
                drawer.close();
            }
        });
    }
});
